export enum PerfilsEnum {
  GESTOR = 'GESTOR', 
  GOVERNO = 'GOVERNO',
  PRIVADO = 'PRIVADO',
  CENTRALCOM = 'CENTRALCOM',
  SEGES = 'SEGES',
  GOVERNO_ESTADUAL_MUNICIPAL = 'GOVERNO_ESTADUAL_MUNICIPAL'
}
